import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './containers/sidebar/sidebar.component';
import { ContentComponent } from './containers/content/content.component';
import { NotesComponent } from './containers/notes/notes.component';
import { ResourcesComponent } from './containers/resources/resources.component';
import { FormsModule } from '@angular/forms';
import { NoteItemComponent } from './containers/notes/note-item/note-item.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MalihuScrollbarModule } from 'ngx-malihu-scrollbar';
import { FormatSecPipe } from './pipes/format-sec.pipe';
import { QandaComponent } from './containers/qanda/qanda.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [SidebarComponent, ContentComponent, NotesComponent, ResourcesComponent, NoteItemComponent, FormatSecPipe, QandaComponent],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    MalihuScrollbarModule.forRoot(),

    SharedModule
  ],
    exports: [SidebarComponent, FormatSecPipe]
})
export class SidebarModule { }
